import store from '@/store'

export default [
  {
    path: '/admin/transfer-by-serials',
    name: 'transfer-by-serial',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/transfer-by-serial/index.vue')
  },
  {
    path: '/admin/transfer-by-serials/create',
    name: 'transfer-by-serial-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/transfer-by-serial/create.vue')
  },
  {
    path: '/admin/transfer-by-serials/:id/show',
    name: 'transfer-by-serial-show',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/transfer-by-serial/show.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('stock/transferBySerial/find', to.params.id)
      next()
    }
  },
  {
    path: '/admin/transfer-by-serials/:id/edit',
    name: 'transfer-by-serial-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/transfer-by-serial/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('stock/transferBySerial/find', to.params.id)
      next()
    }
  }
]
